<template>
  <div class="sidebar-list-card">
    <div class="sidebar-list-card__header">
      <span class="sidebar-list-card__index">{{ index }}</span>
      <span class="sidebar-list-card__titel">{{ title }}</span>
      <slot name="title-append"></slot>
      <button
        v-if="deletable"
        type="button"
        class="sidebar-list-card__delete"
        :title="deleteTitle"
        @click="$emit('delete')"
      >
        <Trash2 :size="16" />
      </button>
      <div v-if="$slots.meta" class="sidebar-list-card__meta">
        <slot name="meta"></slot>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import { Trash2 } from 'lucide-vue';

export default {
  name: 'SidebarListCard',
  components: { Trash2 },
  props: {
    index: { type: Number, required: true },
    title: { type: String, required: true },
    deletable: { type: Boolean, default: false },
    deleteTitle: { type: String, default: 'Löschen' },
  },
};
</script>

<style lang="scss" scoped>
.sidebar-list-card + .sidebar-list-card {
  border-top: 1px solid var(--border);
}

.sidebar-list-card:first-child .sidebar-list-card__header {
  border-radius: var(--radius-md) var(--radius-md) 0 0;
}

// Die unterste Rasterzeile der letzten Karte trägt keine Trennlinie und folgt der Kartenrundung
.sidebar-list-card:last-child :deep(.sidebar-field-grid) > :nth-last-child(-n + 2) {
  border-bottom: none;
}

.sidebar-list-card:last-child :deep(.sidebar-field-grid) > :nth-last-child(2) {
  border-bottom-left-radius: var(--radius-md);
}

.sidebar-list-card:last-child :deep(.sidebar-field-grid) > :last-child {
  border-bottom-right-radius: var(--radius-md);
}

.sidebar-list-card__header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-bottom: 1px solid var(--border);
  background-color: var(--surface-sunken);
}

.sidebar-list-card__index {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 600;
  color: var(--surface);
  background-color: var(--text);
}

.sidebar-list-card__titel {
  font-size: 14px;
  font-weight: 600;
  color: var(--text);
}

.sidebar-list-card__delete {
  display: flex;
  align-items: center;
  padding: 2px;
  border: 0;
  border-radius: var(--radius-sm);
  background: none;
  color: var(--text-subtle);
  cursor: pointer;

  &:hover {
    color: var(--danger);
    background-color: #f64e601a;
  }
}

.sidebar-list-card__meta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}
</style>
